import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Feet() {
	return (
		<g>
			<g className="foot foot--right">

				<path className="fill fill--alt--dark" d="M273.25558,365.79126c-1.5593,0.01904-3.07162-0.21463-4.56967-0.52628
					c-1.49615-0.3205-2.97452-0.73831-4.43576-1.24731c-1.46121-0.50998-2.90976-1.08722-4.33511-1.78918
					c-1.42856-0.68704-2.84091-1.45868-4.20819-2.47455c-1.21716-0.90424-1.47075-2.62372-0.56653-3.84073
					c0.37801-0.50845,0.89948-0.849,1.466-1.00699c1.64053-0.45773,3.23602-0.67133,4.81564-0.80026
					c1.58246-0.14386,3.14178-0.16306,4.68839-0.11499c1.5466,0.04913,3.07639,0.18942,4.58807,0.42688
					c1.5101,0.24646,3.00562,0.57089,4.45416,1.14798c2.71997,1.08347,4.04663,4.16669,2.96307,6.88651
					C277.29776,364.50565,275.33603,365.76349,273.25558,365.79126z" />
				<path className="fill fill--alt" d="M296.23853,358.96097c-1.80371-0.81091-3.61597-1.37393-5.43106-1.85098
					c-1.81448-0.49194-3.63403-0.83789-5.45486-1.15305c-1.82083-0.30405-3.64578-0.48941-5.47357-0.59763
					c-0.15839-0.00888-0.31708-0.0127-0.47546-0.02032v-14.25745c0-2.8717-2.32831-5.20001-5.19998-5.20001
					s-5.20001,2.32831-5.20001,5.20001v15.89642c0,0.24786,0.03937,0.48495,0.073,0.72363
					c-0.73123,0.48624-1.43393,1.00928-2.11819,1.55676c-1.27844,1.02673-2.50989,2.11505-3.66992,3.29761
					c-1.15305,1.19177-2.28735,2.40799-3.33347,3.741c-1.0553,1.32062-2.05887,2.70981-2.91199,4.29703
					c-0.29642,0.55289-0.40561,1.21399-0.25803,1.87448c0.32626,1.46091,1.77545,2.38101,3.23636,2.05441
					c1.75861-0.39261,3.36743-0.98325,4.92419-1.64276c1.56564-0.64716,3.04306-1.41077,4.50208-2.19916
					c1.05719-0.58051,2.06647-1.22415,3.05734-1.89191c0.69696,1.11115,1.42441,2.20483,2.22833,3.25601
					c1.05023,1.35492,2.1268,2.69492,3.33127,3.96347c1.19113,1.27588,2.45749,2.50955,3.94031,3.62198
					c0.51764,0.38657,1.17908,0.59286,1.87286,0.52686c1.48187-0.1409,2.56857-1.45645,2.42767-2.93832
					c-0.17551-1.84558-0.56781-3.56927-1.035-5.2511c-0.45416-1.68912-1.03592-3.30713-1.64435-4.90961
					c-0.10443-0.27008-0.22787-0.52905-0.33832-0.79599c0.57288-0.03397,1.14511-0.05966,1.71863-0.11584
					c1.83765-0.19073,3.67654-0.41226,5.52054-0.78012c1.84335-0.35229,3.68958-0.79092,5.54437-1.47772
					c0.6427-0.24026,1.20065-0.72998,1.50439-1.4054C298.17899,361.14139,297.58041,359.56464,296.23853,358.96097z" />
				
			</g>
			<g className="foot foot--left">
				<path className="fill fill--alt--dark" d="M220.86171,355.56583c1.44885-0.57709,2.94437-0.90152,4.45415-1.14798
					c1.5117-0.23746,3.04149-0.37775,4.58809-0.42688c1.54692-0.04807,3.10623-0.02887,4.68871,0.11499
					c1.57961,0.12894,3.17509,0.34253,4.81564,0.80026c1.46028,0.40753,2.31372,1.92169,1.90652,3.38205
					c-0.17044,0.61008-0.53511,1.11511-1.00706,1.46567c-1.36728,1.01587-2.77995,1.78751-4.20818,2.47455
					c-1.42537,0.70197-2.87422,1.27921-4.33513,1.78918c-1.46155,0.509-2.93961,0.92682-4.43607,1.24731
					c-1.49773,0.31165-3.01006,0.54532-4.56935,0.52628c-2.92755-0.03561-5.27205-2.43781-5.23619-5.36526
					C217.54982,358.21597,218.92981,356.3381,220.86171,355.56583z" />
				<path className="fill fill--alt" d="M238.97154,370.59399c-0.85344-1.58722-1.85669-2.97641-2.91199-4.29703
					c-1.0461-1.33301-2.18074-2.54922-3.33379-3.741c-1.15971-1.18256-2.39148-2.27087-3.66959-3.29761
					c-0.68459-0.54779-1.38759-1.07117-2.11916-1.5574c0.03363-0.23834,0.073-0.47543,0.073-0.72299v-15.89642
					c0-2.8717-2.32832-5.20001-5.20001-5.20001c-2.87167,0-5.2,2.32831-5.2,5.20001v14.25745
					c-0.15805,0.00763-0.31642,0.01144-0.47449,0.02032c-1.8278,0.10822-3.65276,0.29358-5.47389,0.59763
					c-1.82051,0.31516-3.64008,0.6611-5.45486,1.15305c-1.81511,0.47705-3.62737,1.04007-5.43106,1.85098
					c-0.62492,0.28375-1.14828,0.81027-1.40536,1.50473c-0.51099,1.37964,0.19328,2.91199,1.57295,3.42297
					c1.85478,0.6868,3.701,1.12543,5.54436,1.47772c1.84367,0.36786,3.68259,0.58939,5.52055,0.78012
					c0.5732,0.05618,1.14575,0.08188,1.71831,0.11584c-0.11044,0.26694-0.23358,0.52591-0.33832,0.79599
					c-0.60843,1.60248-1.18988,3.22049-1.64404,4.90961c-0.46719,1.68182-0.85948,3.40552-1.03531,5.2511
					c-0.05998,0.64301,0.10918,1.31525,0.52718,1.87256c0.89311,1.19083,2.58253,1.43204,3.77336,0.53891
					c1.48282-1.11243,2.74918-2.3461,3.94031-3.62198c1.20447-1.26855,2.28134-2.60855,3.33157-3.96347
					c0.8036-1.05118,1.53137-2.14487,2.22803-3.25601c0.99086,0.66809,2.00014,1.3114,3.05734,1.89191
					c1.45901,0.78839,2.93643,1.552,4.5024,2.19916c1.55676,0.65952,3.16525,1.25015,4.92387,1.64276
					c0.61255,0.13617,1.27873,0.06253,1.87447-0.25772C239.1861,373.55615,239.68025,371.91272,238.97154,370.59399z" />
				
			</g>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Chicken/Feet.js